import { getLogger } from '@/idv/utils';
import checkIsInIframe from '../../../utils/check-is-in-iframe';
import checkIsInRNWebView from '../../../utils/check-is-in-rn-webview';
import generateEmptyAdapter from './generate-empty-adapter';
import generateIframeAdapter from './generate-iframe-adapter';
import generateRNWebViewAdapter from './generate-rn-web-view-adapter';
import generateWebViewAdapter from './generate-web-view-adapter';

const { logInfo } = getLogger({ location: 'configure-footprint' });

const configureFootprint = () => {
  const IS_SSR = typeof window === 'undefined';

  if (IS_SSR) {
    logInfo('using EmptyAdapter (SSR)');
    return generateEmptyAdapter();
  }

  if (checkIsInIframe()) {
    logInfo('using IframeAdapter');
    return generateIframeAdapter();
  }

  if (checkIsInRNWebView()) {
    logInfo('using RNWebViewAdapter');
    return generateRNWebViewAdapter();
  }

  logInfo('using WebViewAdapter');
  return generateWebViewAdapter();
};

export default configureFootprint;
